<template>
    <div class="col-12 mb-md-5 mb-1 pb-3" role="region" aria-label="Banner Section">
        <slot name="banner"></slot>
    </div>
    <div class="container mb-5">
        <div class="row">
            <div class="col-lg-4 col-12 mt-4" role="region" aria-label="Title Section">
                <slot name="title"></slot>
            </div>
            <div class="col-lg-8 col-12"  role="region" aria-label="Filters Section">
                <slot name="filters"></slot>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8 col-12"  role="region" aria-label="Input Form Section">
                <slot name="form-content"></slot>
            </div>
            <div class="col-lg-4 col-12" role="region" aria-label="Contact address Section">
                <slot name="address"></slot>
            </div>
        </div>
    </div>
</template>
<script>

</script>